import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';
// This is done
const UsePersonalInfo = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>How We Use Your Personal Information</h3>
      <p>
        We use your personal information to provide and improve our services.
        Specifically, we may use your information for the following purposes:
      </p>
      <ul>
        <li>
          <strong>To process transactions and fulfill orders:</strong> This
          includes processing payments through PayPal or other payment
          processors and delivering purchased courses or services.
        </li>
        <li>
          <strong>To manage your account:</strong> This includes creating and
          maintaining user and company accounts, resetting passwords, and
          providing account-related support.
        </li>
        <li>
          <strong>To provide access to the training portal:</strong> This
          includes granting access to courses, quizzes, and other educational
          materials.
        </li>
        <li>
          <strong>To send communications:</strong> This includes sending
          updates, notifications, or newsletters (with your consent) and
          responding to your inquiries or feedback.
        </li>
        <li>
          <strong>To improve our platform:</strong> This includes analyzing user
          behavior to enhance the functionality and user experience of our
          website and services.
        </li>
        <li>
          <strong>To comply with legal obligations:</strong> This includes
          retaining records for tax purposes, preventing fraud, and enforcing
          our terms and conditions.
        </li>
      </ul>
      <p>
        We will only use your personal information for the purposes outlined
        above or as otherwise disclosed to you at the time of collection. If we
        need to use your information for a new purpose, we will seek your
        consent where required by law.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default UsePersonalInfo;
